import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import CallButton from "../components/CallButton";
import SonaPromoModal from "../components/SonaPromoModal";
import logo from "../assets/logo/MC_2607_Logo-02.png";
import { Outlet, Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

const HIDDEN_NAVBAR_PATHS = ['/sport-performance', '/fisio-sport'];

export default function MainLayout() {
  const location = useLocation();
  const hideNavbar = HIDDEN_NAVBAR_PATHS.includes(location.pathname);
  const isHomePage = location.pathname === "/";
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    if (location.pathname !== "/") {
      document.getElementById("hero-loader")?.remove();
    }
  }, [location.pathname]);

  return (
    <>
        {!hideNavbar && <Navbar onMenuToggle={setIsMobileMenuOpen} />}
        {!isHomePage && !isMobileMenuOpen && (
          <Link to="/" className="fixed top-7 left-4 z-30 block xl:hidden">
            <img src={logo} alt="Mcare" className="h-10 w-auto" />
          </Link>
        )}
        <Outlet />
        <Footer />
        <CallButton />
        <SonaPromoModal />
    </>
  );
}